export interface VideoCategory {
  slug: string;
  name: string;
  icon: string;
  description: string;
  color: string;
}

export interface VideoItem {
  id: string;
  title: string;
  category: string;
  thumbnail: string;
  duration: string;
  resolution: string;
  views: number;
  rating: number;
  description: string;
  tags: string[];
  releaseDate: string;
  director?: string;
  cast?: string[];
}

export const videoCategories: VideoCategory[] = [
  {
    slug: 'hot',
    name: '热门推荐',
    icon: 'ri-fire-line',
    description: '全网最受欢迎的热门视频推荐，每日更新精选内容，让您不错过任何精彩。',
    color: '#e53935',
  },
  {
    slug: 'movies',
    name: '电影',
    icon: 'ri-film-line',
    description: '国内外经典电影、最新院线大片，涵盖动作、喜剧、爱情、科幻等多种类型。',
    color: '#f57c00',
  },
  {
    slug: 'tv',
    name: '电视剧',
    icon: 'ri-tv-line',
    description: '热门电视剧全集在线观看，国产剧、韩剧、美剧、日剧一网打尽，更新迅速。',
    color: '#7b1fa2',
  },
  {
    slug: 'variety',
    name: '综艺',
    icon: 'ri-emotion-laugh-line',
    description: '最新综艺节目在线观看，音乐选秀、真人秀、脱口秀、访谈节目精彩不断。',
    color: '#00897b',
  },
  {
    slug: 'anime',
    name: '动漫',
    icon: 'ri-ghost-line',
    description: '热门动漫作品全集，日漫、国漫、欧美动画应有尽有，持续更新中。',
    color: '#ef6c00',
  },
  {
    slug: 'documentary',
    name: '纪录片',
    icon: 'ri-global-line',
    description: '高品质纪录片在线观看，自然、历史、科技、人文等主题，开阔视野。',
    color: '#2e7d32',
  },
];

export const allVideos: VideoItem[] = [
  {
    id: 'v001',
    title: '流浪地球3：星辰大海',
    category: 'movies',
    thumbnail: 'https://readdy.ai/api/search-image?query=Futuristic%20Chinese%20sci-fi%20movie%20poster%20with%20giant%20spaceship%20and%20stars%2C%20dramatic%20lighting%2C%20cinematic%20composition%2C%20warm%20orange%20and%20deep%20space%20contrast%2C%20epic%20scale%2C%20professional%20movie%20poster%20style%20with%20clean%20minimal%20background&width=640&height=360&seq=qiezi-v001&orientation=landscape',
    duration: '02:28:15',
    resolution: '4K',
    views: 12580000,
    rating: 9.2,
    description: '《流浪地球3》延续前作宏大的叙事格局，讲述人类在星际漂流中面临全新危机的史诗故事。地球发动机再次启动，人类命运悬于一线。',
    tags: ['科幻', '灾难', '国产大片', '刘慈欣'],
    releaseDate: '2026-07-15',
    director: '郭帆',
    cast: ['吴京', '刘德华', '李雪健', '赵今麦'],
  },
  {
    id: 'v002',
    title: '长安十二时辰之天机变',
    category: 'movies',
    thumbnail: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20Tang%20dynasty%20period%20drama%20movie%20poster%2C%20warriors%20in%20armor%2C%20traditional%20architecture%2C%20mysterious%20atmosphere%2C%20cinematic%20lighting%2C%20warm%20golden%20tones%2C%20clean%20minimal%20background&width=640&height=360&seq=qiezi-v002&orientation=landscape',
    duration: '01:55:42',
    resolution: '1080P',
    views: 8920000,
    rating: 8.8,
    description: '大唐天宝年间，长安城暗流涌动。一场关乎帝国命运的阴谋正在酝酿，十二时辰内必须揭开真相。',
    tags: ['古装', '悬疑', '动作', '唐朝'],
    releaseDate: '2026-06-20',
    director: '曹盾',
    cast: ['雷佳音', '易烊千玺', '周一围'],
  },
  {
    id: 'v003',
    title: '山海经之异兽觉醒',
    category: 'movies',
    thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%20mythology%20fantasy%20movie%20poster%20with%20ancient%20mythical%20beasts%2C%20mountain%20landscape%2C%20magical%20atmosphere%2C%20ethereal%20lighting%2C%20warm%20earthy%20tones%2C%20clean%20minimal%20background&width=640&height=360&seq=qiezi-v003&orientation=landscape',
    duration: '02:05:30',
    resolution: '1080P',
    views: 6780000,
    rating: 8.5,
    description: '上古奇书《山海经》中的异兽相继苏醒，一位少年意外获得与异兽沟通的能力，踏上拯救世界的冒险旅程。',
    tags: ['奇幻', '冒险', '神话', '国产动画'],
    releaseDate: '2026-05-01',
    director: '赵霁',
    cast: ['张译', '杨紫', '黄渤'],
  },
  {
    id: 'v004',
    title: '穿越火线之终极对决',
    category: 'movies',
    thumbnail: 'https://readdy.ai/api/search-image?query=Modern%20military%20action%20movie%20poster%2C%20soldiers%20in%20tactical%20gear%2C%20intense%20battle%20scene%2C%20dramatic%20cinematic%20lighting%2C%20warm%20desert%20tones%2C%20clean%20minimal%20background&width=640&height=360&seq=qiezi-v004&orientation=landscape',
    duration: '01:48:20',
    resolution: '1080P',
    views: 5430000,
    rating: 8.1,
    description: '国际特种兵大赛期间，一伙神秘武装分子劫持了赛事场馆。各国精英队员放下竞争，携手对抗共同的敌人。',
    tags: ['动作', '军事', '枪战', '现代'],
    releaseDate: '2026-04-10',
    director: '林超贤',
    cast: ['彭于晏', '张涵予', '段奕宏'],
  },
  {
    id: 'v005',
    title: '大江大河之春雷',
    category: 'tv',
    thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%20period%20drama%20TV%20series%20poster%2C%20factory%20and%20countryside%20scenes%20from%20reform%20era%2C%20warm%20nostalgic%20tones%2C%20cinematic%20composition%2C%20clean%20minimal%20background&width=640&height=360&seq=qiezi-v005&orientation=landscape',
    duration: '45分钟/集',
    resolution: '1080P',
    views: 15600000,
    rating: 9.5,
    description: '改革开放的春雷响彻神州大地，三位年轻人在时代的洪流中奋力前行，书写属于他们的奋斗传奇。全42集。',
    tags: ['年代剧', '创业', '励志', '改革开放'],
    releaseDate: '2026-03-15',
    director: '孔笙',
    cast: ['王凯', '杨烁', '董子健'],
  },
  {
    id: 'v006',
    title: '浮生若梦之京城风云',
    category: 'tv',
    thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20romance%20drama%20TV%20series%20poster%2C%20elegant%20traditional%20costumes%2C%20palace%20setting%2C%20soft%20warm%20lighting%2C%20romantic%20atmosphere%2C%20clean%20minimal%20background&width=640&height=360&seq=qiezi-v006&orientation=landscape',
    duration: '50分钟/集',
    resolution: '1080P',
    views: 11200000,
    rating: 8.7,
    description: '清末民初的京城，一位没落贵族小姐与留洋归来的青年才俊之间，上演了一段跨越阶级与时代的爱恨情仇。全36集。',
    tags: ['民国', '爱情', '家族', '年代'],
    releaseDate: '2026-02-18',
    director: '郑晓龙',
    cast: ['赵丽颖', '朱一龙', '刘诗诗'],
  },
  {
    id: 'v007',
    title: '笑傲江湖之风云再起',
    category: 'tv',
    thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%20martial%20arts%20wuxia%20TV%20drama%20poster%2C%20swordsmen%20on%20mountain%20peak%2C%20flowing%20robes%2C%20misty%20landscape%2C%20dramatic%20cinematic%20lighting%2C%20clean%20minimal%20background&width=640&height=360&seq=qiezi-v007&orientation=landscape',
    duration: '48分钟/集',
    resolution: '1080P',
    views: 9800000,
    rating: 8.4,
    description: '经典武侠小说全新改编，令狐冲与任盈盈的传奇故事再度上演。江湖恩怨，爱恨纠葛，一剑泯恩仇。全40集。',
    tags: ['武侠', '古装', '经典改编', '江湖'],
    releaseDate: '2026-01-10',
    director: '李国立',
    cast: ['肖战', '李沁', '王劲松'],
  },
  {
    id: 'v008',
    title: '奔跑吧第十季',
    category: 'variety',
    thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%20variety%20show%20poster%20with%20celebrities%20running%20and%20laughing%2C%20outdoor%20bright%20sunshine%2C%20energetic%20vibrant%20atmosphere%2C%20warm%20colorful%20tones%2C%20clean%20minimal%20background&width=640&height=360&seq=qiezi-v008&orientation=landscape',
    duration: '90分钟/期',
    resolution: '1080P',
    views: 22300000,
    rating: 8.9,
    description: '《奔跑吧》第十季全新出发！原班人马再度集结，更有神秘飞行嘉宾加盟。欢笑与感动，奔跑与挑战，精彩不容错过。',
    tags: ['户外', '竞技', '搞笑', '真人秀'],
    releaseDate: '2026-07-01',
  },
  {
    id: 'v009',
    title: '乘风破浪的姐姐第五季',
    category: 'variety',
    thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%20music%20talent%20show%20poster%20with%20female%20performers%20on%20stage%2C%20spotlight%20and%20glamour%2C%20elegant%20atmosphere%2C%20warm%20golden%20lighting%2C%20clean%20minimal%20background&width=640&height=360&seq=qiezi-v009&orientation=landscape',
    duration: '120分钟/期',
    resolution: '4K',
    views: 18900000,
    rating: 8.6,
    description: '30位30+姐姐再度集结，用实力证明年龄只是数字。舞台之上，她们是最耀眼的星。全新赛制，更多惊喜！',
    tags: ['音乐', '竞演', '女性', '励志'],
    releaseDate: '2026-06-15',
  },
  {
    id: 'v010',
    title: '吐槽大会第八季',
    category: 'variety',
    thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%20comedy%20talk%20show%20poster%2C%20comedian%20on%20stage%20with%20microphone%2C%20spotlight%2C%20humorous%20atmosphere%2C%20warm%20stage%20lighting%2C%20clean%20minimal%20background&width=640&height=360&seq=qiezi-v010&orientation=landscape',
    duration: '60分钟/期',
    resolution: '1080P',
    views: 14500000,
    rating: 8.3,
    description: '吐槽大会第八季爆笑回归！全新阵容，更犀利的吐槽，更劲爆的话题。让笑声成为最好的解压方式。',
    tags: ['脱口秀', '喜剧', '吐槽', '综艺'],
    releaseDate: '2026-05-20',
  },
  {
    id: 'v011',
    title: '斗破苍穹之炎帝归来',
    category: 'anime',
    thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%20anime%20donghua%20poster%20with%20young%20warrior%20wielding%20flame%20powers%2C%20fantasy%20world%2C%20epic%20battle%20stance%2C%20vibrant%20warm%20fire%20colors%2C%20clean%20minimal%20background&width=640&height=360&seq=qiezi-v011&orientation=landscape',
    duration: '25分钟/集',
    resolution: '1080P',
    views: 20100000,
    rating: 9.1,
    description: '萧炎历尽千辛万苦终于突破至斗帝境界，然而远古的黑暗势力正在悄然苏醒。炎帝归来，风云再起！全52集。',
    tags: ['玄幻', '热血', '战斗', '国产动画'],
    releaseDate: '2026-07-10',
  },
  {
    id: 'v012',
    title: '一人之下第六季',
    category: 'anime',
    thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%20modern%20supernatural%20anime%20poster%20with%20urban%20setting%20and%20mystical%20powers%2C%20young%20characters%2C%20dynamic%20action%20pose%2C%20warm%20earthy%20tones%2C%20clean%20minimal%20background&width=640&height=360&seq=qiezi-v012&orientation=landscape',
    duration: '24分钟/集',
    resolution: '1080P',
    views: 16800000,
    rating: 9.3,
    description: '异人世界的秘密逐渐浮出水面，张楚岚与冯宝宝踏上全新的冒险旅程。真相与阴谋，友情与背叛。全24集。',
    tags: ['都市', '异能', '国漫', '冒险'],
    releaseDate: '2026-06-01',
  },
  {
    id: 'v013',
    title: '三体之黑暗森林',
    category: 'anime',
    thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%20sci-fi%20anime%20poster%20with%20cosmic%20space%20and%20mysterious%20alien%20civilization%2C%20dark%20universe%20atmosphere%2C%20scientific%20elements%2C%20clean%20minimal%20background&width=640&height=360&seq=qiezi-v013&orientation=landscape',
    duration: '30分钟/集',
    resolution: '4K',
    views: 18700000,
    rating: 9.6,
    description: '《三体》动画系列第二季——黑暗森林。面壁计划正式启动，人类文明与三体文明之间的博弈进入全新阶段。全30集。',
    tags: ['科幻', '宇宙', '硬核', '国产动画'],
    releaseDate: '2026-08-01',
  },
  {
    id: 'v014',
    title: '地球脉动之亚洲秘境',
    category: 'documentary',
    thumbnail: 'https://readdy.ai/api/search-image?query=Nature%20documentary%20poster%20with%20Asian%20landscapes%20mountains%20forests%20and%20wildlife%2C%20stunning%20aerial%20photography%2C%20warm%20natural%20light%2C%20clean%20minimal%20background&width=640&height=360&seq=qiezi-v014&orientation=landscape',
    duration: '55分钟/集',
    resolution: '4K',
    views: 7800000,
    rating: 9.5,
    description: 'BBC级别制作团队深入亚洲大陆，探索从喜马拉雅山脉到东南亚热带雨林的自然奇观。前所未有的视觉震撼。全8集。',
    tags: ['自然', '地理', '野生动物', '亚洲'],
    releaseDate: '2026-04-20',
  },
  {
    id: 'v015',
    title: '舌尖上的中国第五季',
    category: 'documentary',
    thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%20food%20documentary%20poster%20with%20traditional%20cuisine%20and%20cooking%20scenes%2C%20steaming%20dishes%2C%20warm%20kitchen%20atmosphere%2C%20rich%20food%20photography%2C%20clean%20minimal%20background&width=640&height=360&seq=qiezi-v015&orientation=landscape',
    duration: '50分钟/集',
    resolution: '1080P',
    views: 13200000,
    rating: 9.4,
    description: '跨越中国34个省级行政区，寻访300多种地道美食。从食材到餐桌，每一道菜都承载着中国人的情感与记忆。全10集。',
    tags: ['美食', '文化', '旅行', '中国'],
    releaseDate: '2026-03-08',
  },
  {
    id: 'v016',
    title: '敦煌：千年回响',
    category: 'documentary',
    thumbnail: 'https://readdy.ai/api/search-image?query=Documentary%20about%20Dunhuang%20caves%20with%20ancient%20Buddhist%20murals%20and%20desert%20landscape%2C%20historical%20atmosphere%2C%20warm%20sandstone%20tones%2C%20clean%20minimal%20background&width=640&height=360&seq=qiezi-v016&orientation=landscape',
    duration: '60分钟/集',
    resolution: '4K',
    views: 5600000,
    rating: 9.3,
    description: '千年敦煌，丝路明珠。从莫高窟壁画到藏经洞文献，讲述敦煌两千年的辉煌历史与文化交融。全6集。',
    tags: ['历史', '文化', '佛教', '丝绸之路'],
    releaseDate: '2026-02-05',
  },
];

export const hotVideos = allVideos.filter((v) =>
  ['v001', 'v005', 'v008', 'v011', 'v013', 'v015', 'v002', 'v009']
    .includes(v.id)
);

export const newVideos = allVideos.filter((v) =>
  ['v013', 'v001', 'v008', 'v011', 'v002', 'v005']
    .includes(v.id)
);

export function getVideosByCategory(slug: string): VideoItem[] {
  return allVideos.filter((v) => v.category === slug);
}

export function getVideoById(id: string): VideoItem | undefined {
  return allVideos.find((v) => v.id === id);
}